import { useRouter } from "next/router";
import { createContext, useContext, useEffect, useState } from "react";
import { MainContext } from "./MainContext";
type user = {
    first_name: string;
    full_name: string;
    id: number;
    type: string;
    updated_at: string;
    active: boolean;
    avatar_location: string | null;
    created_at: string;
    deleted_at: string;

}
type SessionContextType = {
    session: any;
    setSession: (value: string) => void;
    storeSession: (keyValue: string, value: string) => void;
    destroySession: () => void;
    Session: () => void;
    User: () => void;
}

const SessionContextDefault: SessionContextType = {
    session: undefined,
    setSession: () => {},
    storeSession: () => {},
    destroySession: () => {},
    Session: () => {},
    User: () => {}
}

const SessionContext = createContext(SessionContextDefault)

const SessionProvider = ({ children }: any) => {
    const [session, setSession] = useState(undefined)
    const { setIsLoading } = useContext(MainContext);
    const router = useRouter()
    const storeSession = async (keyValue: string, value: string) => {
        let session: any = {
            [keyValue] : value
        }
        if(localStorage.getItem('session')==null)
        {
            await localStorage.setItem('session', JSON.stringify(session))
        }
        else
        {
            let sessionData: any = await localStorage.getItem('session')
            sessionData = JSON.parse(sessionData)
            
            let addNew = {
                ...sessionData,
                [keyValue]: value
            }
            await localStorage.setItem('session', JSON.stringify(addNew))
        }
        let data = await localStorage.getItem('session')
        data = JSON.parse(data)
        setSession(data)
    }

    const destroySession = async () => {
        setIsLoading(true);
        await localStorage.removeItem('session')
        router.push('/')
    }
    const Session = async () => {
        let data = await localStorage.getItem('session')
        if(data!=null)
        {
            data = await JSON.parse(data)
            await setSession(data)
        }
        return data
    }

    const User = () => {
        return session!=undefined ? session.user : null
    }

    useEffect(() => {
        Session()
    }, [])

    return (
        <SessionContext.Provider value={{ 
            session, setSession,
            storeSession,
            destroySession,
            Session,
            User
        }}>
            { children }
        </SessionContext.Provider>
    )
}

export {SessionProvider, SessionContext}